import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';
import { rOyakKiraBilgileriUstBilgiAkgDetay } from '../../../../api/models/rOyakKiraBilgileriUstBilgiAkgDetay';
export default ApiBaseReducer<
  pList,
  IInputDataStateModel<pList, rOyakKiraBilgileriUstBilgiAkgDetay>,
  rOyakKiraBilgileriUstBilgiAkgDetay
>(
  ActionSubTypes.API_OYAKKIRABILGILERIUSTBILGIAKGDETAY,
  DefaultInputDataStateModel<pList, rOyakKiraBilgileriUstBilgiAkgDetay>()
);
